import { useState, useRef, useEffect } from "react"
import { DashboardHeader } from "@/components/dashboard-header"
import { FileUploadCard } from "@/components/file-upload-card"
import { UploadCompleteCard } from "@/components/upload-complete-card"
import { TransferPreview } from "@/components/transfer-preview"

type UploadState = "idle" | "uploading"

export default function Dashboard() {
  const [uploadState, setUploadState] = useState<UploadState>("idle")
  const [uploadProgress, setUploadProgress] = useState(0)
  const [showPreview, setShowPreview] = useState(false)
  const uploadIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const handleStartUpload = () => {
    setUploadState("uploading")
    setUploadProgress(0)

    // 清除之前的定时器（如果存在）
    if (uploadIntervalRef.current) {
      clearInterval(uploadIntervalRef.current)
      uploadIntervalRef.current = null
    }

    // Simulate upload progress
    uploadIntervalRef.current = setInterval(() => {
      setUploadProgress((prev) => {
        // 已经完成，清理定时器
        if (prev >= 100) {
          if (uploadIntervalRef.current) {
            clearInterval(uploadIntervalRef.current)
            uploadIntervalRef.current = null
          }
          setShowPreview(true)
          return 100
        }
        
        // 计算随机增量，范围 3-8
        const randomIncrement = Math.random() * 5 + 3
        const next = prev + randomIncrement
        
        // 如果下一次会超过或等于100，直接设为100
        if (next >= 100) {
          if (uploadIntervalRef.current) {
            clearInterval(uploadIntervalRef.current)
            uploadIntervalRef.current = null
          }
          setShowPreview(true)
          return 100
        }
        
        return next
      })
    }, 500)
  }

  const handleTransferAgain = () => {
    // 清理定时器
    if (uploadIntervalRef.current) {
      clearInterval(uploadIntervalRef.current)
      uploadIntervalRef.current = null
    }
    setUploadState("idle")
    setUploadProgress(0)
    setShowPreview(false)
  }

  // 组件卸载时清理定时器
  useEffect(() => {
    return () => {
      if (uploadIntervalRef.current) {
        clearInterval(uploadIntervalRef.current)
        uploadIntervalRef.current = null
      }
    }
  }, [])

  // handleCopy 已移至组件内部处理

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-100 via-blue-50 to-cyan-50 relative overflow-hidden">
      {/* Background decorative blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-200/30 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      <div className="absolute bottom-20 left-20 w-64 h-64 bg-pink-200/20 rounded-full blur-3xl" />

      <DashboardHeader />

      <main className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid lg:grid-cols-[400px_1fr] gap-8">
          <div>
            {uploadState === "idle" && <FileUploadCard onStartUpload={handleStartUpload} />}
            {uploadState === "uploading" && (
              <UploadCompleteCard 
                progress={uploadProgress} 
                shareLink={uploadProgress >= 100 ? "https://easyshare.local/s/demo88" : ""}
                shareCode={uploadProgress >= 100 ? "DEMO88" : ""}
                onTransferAgain={handleTransferAgain}
              />
            )}
          </div>

          <div>{showPreview && <TransferPreview />}</div>
        </div>
      </main>
    </div>
  )
}
